/**
 * Contract Catalog Mapper
 * Maps between transport (LC_*) and domain models
 */

import type {
  LC_ContractStatusItem,
  LC_ContractTypeItem,
  LC_ContractModalityItem,
  ContractStatus,
  ContractType,
  ContractModality,
} from './contract.types.ts';

/**
 * Map LC_ContractStatusItem to ContractStatus
 */
export function mapContractStatusOutToModel(item: LC_ContractStatusItem): ContractStatus {
  return {
    id: item.contractStatusId,
    name: item.contractStatus,
  };
}

/**
 * Map LC_ContractTypeItem to ContractType
 */
export function mapContractTypeOutToModel(item: LC_ContractTypeItem): ContractType {
  return {
    id: item.contractTypeId,
    name: item.contractType,
  };
}

/**
 * Map LC_ContractModalityItem to ContractModality
 */
export function mapContractModalityOutToModel(item: LC_ContractModalityItem): ContractModality {
  return {
    id: item.contractModalityId,
    name: item.contractModality,
  };
}
